import { useEffect, useState } from 'react';

interface ICountDownTime {
  seconds: number;
  size: number;
  strokeBgColor: string;
  strokeColor: string;
  strokeWidth: number;
  onExpiry?: () => void;
}

const CountDownTime = ({
  seconds,
  size,
  strokeBgColor,
  strokeColor,
  strokeWidth,
  onExpiry,
}: ICountDownTime) => {
  const milliseconds = seconds * 1000;
  const radius = size / 2;
  const circumference = size * Math.PI;
  const [countdown, setCountdown] = useState(milliseconds);
  const countdownSizeStyles = {
    height: size,
    width: size,
  };

  const textStyles = {
    color: strokeColor,
    fontSize: size * 0.3,
  };

  useEffect(() => {
    if (countdown <= 0) {
      onExpiry && onExpiry();
      return;
    }
    setTimeout(() => {
      setCountdown(countdown - 1000);
    }, 1000);
  }, [countdown, onExpiry]);

  const strokeDashoffset = () => circumference - (countdown / milliseconds) * circumference;

  return (
    <div style={Object.assign({}, styles.countdownContainer, countdownSizeStyles)}>
      <p style={textStyles}>{countdown / 1000}s</p>
      <svg style={styles.svg}>
        <circle
          cx={radius}
          cy={radius}
          r={radius}
          fill="none"
          stroke={strokeBgColor}
          strokeWidth={strokeWidth}
        ></circle>
      </svg>
      <svg style={styles.svg}>
        <circle
          strokeDasharray={circumference}
          strokeDashoffset={countdown > 0 ? strokeDashoffset() : 0}
          r={radius}
          cx={radius}
          cy={radius}
          fill="none"
          strokeLinecap="round"
          stroke={strokeColor}
          strokeWidth={strokeWidth}
        ></circle>
      </svg>
    </div>
  );
};

export default CountDownTime;

const styles = {
  countdownContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
    margin: 'auto',
  } as React.CSSProperties,
  svg: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    transform: 'rotateY(-180deg) rotateZ(-90deg)',
    overflow: 'visible',
  } as React.CSSProperties,
};
